import { initClickTracking } from './click-tracking';

jQuery(function($)
{
    var $navMain = $('#nav-main');

    function centerMegaDropdownArrow()
    {
        var
            $dropdown = $(this),
            $arrow = $('.locator', this),
            $trigger = $('[data-target=' + $dropdown.attr('id') + ']');

        $arrow.css('left', $trigger.position().left + $trigger.width() / 2);
    }

    function centerMegaDropdownArrows()
    {
        $('.dropdown.mega', $navMain).each(centerMegaDropdownArrow);
    }

    $navMain.on(orion.constants.EventNavigationAppended, centerMegaDropdownArrows);

    $(window).on('resize', centerMegaDropdownArrows);

    initClickTracking();
});
